import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistleOvertimeStartSecondHalftime extends DomainEvent<MatchEvent> {}
